var BillingView = (function () {
  var credit_card_form_selector = '#credit_card_form';
  var paypal_form_selector = '#paypal_form';
  var billing_method_form_selector = '#billing_method_form';
  var selected_billing_method_selector = 'input[name=\'billing_profile[displayed_billing_method]\']';
  var cc_collection_selector = '#cc-collection';

  function showPaypalBilling() {
    $(credit_card_form_selector).slideUp('fast');
    $(paypal_form_selector).slideDown('fast');
  }

  function showCreditCardBilling() {
    $(credit_card_form_selector).slideDown('fast');
    $(paypal_form_selector).slideUp('fast');
  }

  function onBillingPage() {
    return $(billing_method_form_selector).length !== 0;
  }

  function creditCardIsSelected() {
    return $(selected_billing_method_selector + ':checked').val() == 'credit_card';
  }

  function showSelectedBillingMethod() {
    if (creditCardIsSelected()) {
      showCreditCardBilling();
    } else {
      showPaypalBilling();
    }
  }

  function bindMethodSelectionEvent() {
    $(selected_billing_method_selector).click(function () {
      showSelectedBillingMethod();
    });
  }

  function init() {
    if (!onBillingPage()) { return; }
    bindMethodSelectionEvent();

    $(document).ready(function () {
      $.fancybox($(cc_collection_selector));
    });
  }

  return {
    init: init
  };
})();

$(function () { BillingView.init(); });



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dashboard/selling/billing.js